import axios from 'axios';
import { BACKEND_URL } from '../Constants';

const API = axios.create({
  baseURL: `${ BACKEND_URL }/api`, // backend URL
});

// Attach token if exists
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});

export default API;

// api.js or services/api.js
export const createCourse = (data) => {
  return API.post('/courses', data); // POST to your backend
};

export const getCourses = () => API.get('/courses');

// Get course by ID
export const getCourseDetails = (id) => {
  return API.get(`/courses/${id}`);
};